export default __webpack_public_path__ + "static/media/quotationHistory.8e517983.svg";